import request from "@/utils/request";

export function getOrders(page =1) {
    return request({
        url: "/scores/list",
        method: "get",
        params: {
            page
        }
    });
}

export function createOrder(data) {
    return request({
        url: '/order/create',
        method: 'post',
        data
    });
}
